// Switches off the seeded e2e-org override (ENG-539/540); ephemeral-only, see
// api-stack/flagd/README.md. Only 'true' counts, as for isE2eTestOrg.
export const parseIgnoreE2eOrgOverride = (
  value: string | undefined | null
): boolean => value === 'true';
